import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-mention",
  templateUrl: "./med-icon-mention.component.html",
  styles: [
  ],
})
export class MedIconMentionComponent extends SvgMixinComponent {}
